export const removeEmptyValues = (obj: any): any => {
  if (Array.isArray(obj)) {
    const filteredArray = obj
      .map(removeEmptyValues)
      .filter(
        item =>
          item !== undefined && !(Array.isArray(item) && item.length === 0)
      );

    return filteredArray.length > 0 ? filteredArray : undefined;
  }

  if (typeof obj === 'object' && obj !== null) {
    const result: any = {};

    for (const [key, value] of Object.entries(obj)) {
      const cleanedValue = removeEmptyValues(value);

      const isEmptyObject =
        typeof cleanedValue === 'object' &&
        !Array.isArray(cleanedValue) &&
        cleanedValue &&
        Object.keys(cleanedValue).length === 0;

      if (
        cleanedValue !== undefined &&
        cleanedValue !== '' &&
        !isEmptyObject &&
        !(Array.isArray(cleanedValue) && cleanedValue.length === 0)
      ) {
        result[key] = cleanedValue;
      }
    }

    return Object.keys(result).length > 0 ? result : undefined;
  }

  return obj === '' ? undefined : obj;
};
